import { Pipe, PipeTransform } from "@angular/core";
import { ReflectionLabel, ReflectionOverviewFilterName } from "../models/reflections.models";

@Pipe({ name: "filterLabels" })
export class LabelsFilterPipe implements PipeTransform {
  public transform(labels: ReflectionLabel[], filter: ReflectionOverviewFilterName): ReflectionLabel[] {
    if (labels && filter && filter !== "published") {
      return labels.filter((label) => label.type === filter);
    }
    return labels;
  }
}
